module.exports = __webpack_public_path__ + "img/slide-news.a70b1a0d.png";